// src/components/CancelDialog.tsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  TextField,
  MenuItem,
  FormControlLabel,
  Checkbox,
} from "@mui/material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import api from "../api/axios";
import { ESTADOS_CANCELLED } from "../constants/enums";

interface Props {
  open: boolean;
  reservaId: number;
  onClose: () => void;
  onSaved: () => void;
}

export default function CancelDialog({ open, reservaId, onClose, onSaved }: Props) {
  const { t } = useTranslation<"translation">();

  const [estado, setEstado] = useState<string | "">("");
  const [comentarios, setComentarios] = useState("");
  const [incidencia, setIncidencia] = useState(false);
  const [saving, setSaving] = useState(false);

  const handleSave = async () => {
    setSaving(true);
    try {
      const payload: any = {};
      if (estado) payload.estado = estado; // code o label (backend acepta ambos)
      if (incidencia) payload.incidencia = true;
      if (comentarios.trim()) payload.comentariosInternos = comentarios.trim();

      await api.patch(`/reservas/${reservaId}`, payload);
      onSaved();
    } finally {
      setSaving(false);
    }
  };

  const comentarioOblig = !estado && !incidencia ? false : comentarios.trim().length === 0;

  const guardarDisabled = saving || comentarioOblig;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t("cancelDialog.title")}</DialogTitle>

      <DialogContent dividers>
        {/* Estado (opcional) */}
        <TextField
          select
          fullWidth
          margin="normal"
          label={t("cancelDialog.newState")}
          value={estado}
          onChange={(e) => setEstado(e.target.value as string)}
        >
          <MenuItem value="">
            <em>{t("cancelDialog.noChange")}</em>
          </MenuItem>
          {ESTADOS_CANCELLED.map((s) => (
            <MenuItem key={s} value={s}>
              {s}
            </MenuItem>
          ))}
        </TextField>

        {/* Comentario */}
        <TextField
          multiline
          rows={3}
          fullWidth
          margin="normal"
          label={t("cancelDialog.commentLabel")}
          value={comentarios}
          onChange={(e) => setComentarios(e.target.value)}
          error={comentarioOblig}
          helperText={comentarioOblig ? t("cancelDialog.commentHelper") : " "}
        />

        {/* Incidencia */}
        <FormControlLabel
          control={
            <Checkbox checked={incidencia} onChange={(e) => setIncidencia(e.target.checked)} />
          }
          label={t("cancelDialog.markIssue")}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose} disabled={saving}>
          {t("common.close")}
        </Button>
        <Button variant="contained" color="error" onClick={handleSave} disabled={guardarDisabled}>
          {t("common.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
